import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import {
  LayoutDashboard,
  Newspaper,
  Calendar,
  Trophy,
  Users,
  BookOpen,
  FileText,
  Phone,
  Star,
  Settings,
  LogOut,
  Menu,
  X,
  ChevronRight,
  MessageSquare,
  User
} from 'lucide-react';
import { toast } from 'sonner';

const AdminLayout = ({ children, addButton }) => {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [user, setUser] = useState(null);
  const [settings, setSettings] = useState({});
  const [logoType, setLogoType] = useState('kolej');
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    checkAuth();
    const savedLogoType = localStorage.getItem('siteLogo') || 'kolej';
    setLogoType(savedLogoType);
    fetchSettings();
  }, []);

  useEffect(() => {
    if (Object.keys(settings).length > 0) {
      updateFavicon();
    }
  }, [settings, logoType]);

  const updateFavicon = () => {
    const faviconLink = document.querySelector("link[rel~='icon']") || document.createElement('link');
    faviconLink.rel = 'icon';
    const faviconUrl = logoType === 'kurs-merkezi'
      ? (settings.kurs_merkezi_favicon || '/favicon.ico')
      : (settings.kolej_favicon || '/favicon.ico');
    faviconLink.href = faviconUrl;
    if (!document.querySelector("link[rel~='icon']")) {
      document.getElementsByTagName('head')[0].appendChild(faviconLink);
    } else {
      // Mevcut favicon link'ini güncelle
      const existingLink = document.querySelector("link[rel~='icon']");
      if (existingLink) {
        existingLink.href = faviconUrl;
      }
    }
  };

  const checkAuth = async () => {
    try {
      const response = await fetch('http://localhost/api/auth.php?check', {
        credentials: 'include',
      });
      
      if (!response.ok) {
        navigate('/sahinserpil4409');
        return;
      }
      
      const data = await response.json();
      
      if (data.authenticated) {
        setUser(data.user);
      } else {
        navigate('/sahinserpil4409');
      }
    } catch (error) {
      console.error('Auth check error:', error);
      navigate('/sahinserpil4409');
    }
  };

  const fetchSettings = async () => {
    try {
      const response = await fetch('http://localhost/api/settings.php', {
        credentials: 'include',
      });
      if (response.ok) {
        const text = await response.text();
        const data = text ? JSON.parse(text) : {};
        setSettings(data);
      }
    } catch (error) {
      console.error('Error fetching settings:', error);
    }
  };

  const handleLogout = async () => {
    try {
      const response = await fetch('http://localhost/api/auth.php?action=logout', {
        method: 'POST',
        credentials: 'include',
      });
      
      if (response.ok) {
        toast.success('Çıkış yapıldı');
      }
      navigate('/sahinserpil4409');
    } catch (error) {
      console.error('Logout error:', error);
      navigate('/sahinserpil4409');
    }
  };

  const adminLogoSrc = logoType === 'kurs-merkezi'
    ? (settings.kurs_merkezi_logo || '/kursmerkezi.png')
    : (settings.kolej_logo || '/logo.png');

  const menuItems = [
    {
      title: 'Dashboard',
      icon: <LayoutDashboard size={20} />,
      path: '/admin/dashboard',
      pageTitle: 'Dashboard',
      pageDescription: 'Yönetim paneline hoş geldiniz',
    },
    {
      title: 'Site Ayarları',
      icon: <Settings size={20} />,
      path: '/admin/site-ayarlari',
      pageTitle: 'Site Ayarları',
      pageDescription: 'Logolar, faviconlar, hero resimler ve footer bilgilerini yönetin',
    },
    {
      title: 'Mesajlar',
      icon: <MessageSquare size={20} />,
      path: '/admin/mesajlar',
      pageTitle: 'Mesaj Yönetimi',
      pageDescription: 'İletişim formundan gelen mesajları görüntüleyin ve yönetin',
    },
    {
      title: 'Neden Biz?',
      icon: <Star size={20} />,
      path: '/admin/core-values',
      pageTitle: 'Neden Biz? Yönetimi',
      pageDescription: 'Ana sayfadaki değerler bölümünü yönetin',
    },
    {
      title: 'Eğitim Kademeleri',
      icon: <BookOpen size={20} />,
      path: '/admin/egitim-kademeleri',
      pageTitle: 'Eğitim Kademeleri Yönetimi',
      pageDescription: 'Eğitim kademelerini ve içeriklerini yönetin',
    },
    {
      title: 'Haberler',
      icon: <Newspaper size={20} />,
      path: '/admin/haberler',
      pageTitle: 'Haber Yönetimi',
      pageDescription: 'Okul haberlerini ekleyin, düzenleyin ve yayınlayın',
    },
    {
      title: 'Etkinlikler',
      icon: <Calendar size={20} />,
      path: '/admin/etkinlikler',
      pageTitle: 'Etkinlik Yönetimi',
      pageDescription: 'Okul etkinliklerini yönetin ve planlayın',
    },
    {
      title: 'Başarılar',
      icon: <Trophy size={20} />,
      path: '/admin/basarilar',
      pageTitle: 'Başarı Yönetimi',
      pageDescription: 'Okulun başarılarını sergileyin',
    },
    {
      title: 'Hakkımızda',
      icon: <Users size={20} />,
      path: '/admin/hakkimizda',
      pageTitle: 'Hakkımızda Yönetimi',
      pageDescription: 'Hakkımızda sayfası içeriğini düzenleyin',
    },
    {
      title: 'Kabul ve Kayıt',
      icon: <FileText size={20} />,
      path: '/admin/kabul',
      pageTitle: 'Kabul ve Kayıt Yönetimi',
      pageDescription: 'Kabul sayfası içeriğini düzenleyin',
    },
    {
      title: 'Yasal Sayfalar',
      icon: <FileText size={20} />,
      path: '/admin/yasal-sayfalar',
      pageTitle: 'Yasal Sayfalar Yönetimi',
      pageDescription: 'Gizlilik politikası ve kullanım şartlarını düzenleyin',
    },
  ];

  // Mevcut sayfa başlığını ve açıklamasını bul
  const currentPage = menuItems.find(item => item.path === location.pathname);
  const pageTitle = currentPage?.pageTitle || 'Yönetici Paneli';
  const pageDescription = currentPage?.pageDescription || '';

  // Mobilde sidebar açıkken overlay göster ve sidebar'ı kapat
  useEffect(() => {
    if (sidebarOpen && window.innerWidth < 1024) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [sidebarOpen]);

  // Sayfa değiştiğinde mobilde sidebar'ı kapat
  useEffect(() => {
    if (window.innerWidth < 1024) {
      setSidebarOpen(false);
    }
  }, [location.pathname]);

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Mobile Sidebar Overlay */}
      {sidebarOpen && (
        <div
          className="lg:hidden fixed inset-0 bg-black/50 z-[45]"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      {/* Mobile Sidebar Toggle - Navbar */}
      <div className="lg:hidden fixed top-0 left-0 right-0 bg-white shadow-md p-3 flex items-center justify-between gap-2 z-50">
        <h1 className="text-lg font-bold text-gray-900 truncate flex-1 min-w-0">Yönetici Paneli</h1>
        {location.pathname !== '/admin/dashboard' && addButton && (
          <div className="flex-shrink-0">
            {addButton}
          </div>
        )}
        <button
          onClick={() => setSidebarOpen(!sidebarOpen)}
          className="p-2 rounded-lg hover:bg-gray-100 flex-shrink-0"
          aria-label="Menü"
        >
          {sidebarOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Sidebar */}
      <aside
        className={`fixed top-0 left-0 h-full bg-gradient-to-b from-red-900 to-red-800 text-white transition-all duration-300 ${
          sidebarOpen ? 'w-64 z-[55]' : 'w-0 lg:w-20 z-40'
        } overflow-hidden`}
      >
        <div className="h-full flex flex-col">
          {/* Logo */}
          <div className="p-6 border-b border-red-800">
            <div className="flex items-center gap-3">
              <div className="relative w-14 h-14 flex items-center justify-center flex-shrink-0">
                <img 
                  src={adminLogoSrc}
                  alt={logoType === 'kurs-merkezi' ? 'Kurs Merkezi' : 'Serpil Şahin Koleji'}
                  className="h-full w-auto object-contain brightness-0 invert"
                  onError={(e) => {
                    e.target.style.display = 'none';
                    const fallback = e.target.parentElement.querySelector('.logo-fallback');
                    if (fallback) fallback.style.display = 'flex';
                  }}
                />
                <div className="logo-fallback hidden absolute inset-0 items-center justify-center w-14 h-14 rounded-lg bg-white/10" style={{display: 'none'}}>
                  <LayoutDashboard size={28} />
                </div>
              </div>
              {sidebarOpen && (
                <div>
                  <h2 className="font-bold text-lg">Yönetici Paneli</h2>
                  <p className="text-xs text-red-200">{logoType === 'kurs-merkezi' ? 'Kurs Merkezi' : 'Serpil Şahin Koleji'}</p>
                </div>
              )}
            </div>
          </div>

          {/* Menu Items */}
          <nav className="flex-1 overflow-y-auto p-4">
            <ul className="space-y-2">
              {menuItems.map((item) => {
                const isActive = location.pathname === item.path;
                return (
                  <li key={item.path}>
                    <Link
                      to={item.path}
                      className={`flex items-center gap-3 px-4 py-3 rounded-lg transition-all ${
                        isActive
                          ? 'bg-white/20 text-white shadow-lg'
                          : 'text-red-100 hover:bg-white/10 hover:text-white'
                      }`}
                      onClick={() => window.innerWidth < 1024 && setSidebarOpen(false)}
                    >
                      {item.icon}
                      {sidebarOpen && <span className="flex-1">{item.title}</span>}
                      {sidebarOpen && isActive && (
                        <ChevronRight size={16} className="ml-auto" />
                      )}
                    </Link>
                  </li>
                );
              })}
            </ul>
          </nav>

          {/* User Info & Logout */}
          <div className="p-4 border-t border-red-800">
            {sidebarOpen && user && (
              <div className="mb-4 p-3 bg-white/10 rounded-lg">
                <div className="flex items-center gap-2 mb-1">
                  <div className="w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0" style={{ backgroundColor: '#C0A062' }}>
                    <User size={16} className="text-white" />
                  </div>
                  <p className="text-sm font-semibold">{user.full_name}</p>
                </div>
                <p className="text-xs text-red-200">{user.email}</p>
              </div>
            )}
            <button
              onClick={handleLogout}
              className="w-full flex items-center gap-3 px-4 py-3 rounded-lg text-red-100 hover:bg-white/10 hover:text-white transition-all"
            >
              <LogOut size={20} />
              {sidebarOpen && <span>Çıkış Yap</span>}
            </button>
          </div>
        </div>
      </aside>

      {/* Top Navbar - PC için */}
      <header className={`hidden lg:flex fixed top-0 right-0 bg-white shadow-md z-30 transition-all duration-300 ${sidebarOpen ? 'left-64' : 'left-20'}`}>
        <div className="w-full px-6 py-4 flex items-center justify-between gap-4">
          <div className="flex flex-col gap-1 min-w-0 flex-1">
            <h1 className="text-xl font-bold text-gray-900 truncate">{pageTitle}</h1>
            {pageDescription && (
              <p className="text-sm text-gray-600">{pageDescription}</p>
            )}
          </div>
          <div className="flex items-center gap-4 flex-shrink-0">
            {location.pathname !== '/admin/dashboard' && addButton}
          </div>
        </div>
      </header>

      {/* Main Content */}
      <div className={`transition-all duration-300 ${sidebarOpen ? 'lg:ml-64' : 'lg:ml-20'}`}>
        <div className="min-h-screen pt-14 sm:pt-16 lg:pt-20">
          <div className="p-3 sm:p-4 lg:p-6 xl:p-8">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminLayout;

